import React from "react";
import "./button.css";

const Button = ({ 
  type = "red", 
  children, 
  borderColor, 
  hoverColor, 
  onClick, 
  ...props 
}) => {
  
  const outlinedStyles =
    type === "outlined"
      ? {
          borderColor: borderColor || "#C12328",
          color: borderColor || "#C12328",
        }
      : {};

  const outlinedHoverVar =
    type === "outlined" && hoverColor
      ? { "--outlined-hover-color": hoverColor }
      : {};

  return (
    <button
      className={`custom-btn ${type}-btn`}
      onClick={onClick}
      style={{ ...outlinedStyles, ...outlinedHoverVar }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
